<script setup lang="ts">
import logo from '#assets/images/logo.svg'

import RPanel from '../RPanel/RPanel.vue'

import RHeroStyle from './RHero.style.ts'
</script>

<template>
  <RPanel
    class="r-hero-panel"
    :pt="RHeroStyle"
  >
    <template #header>
      <img
        :src="logo"
        class="w-36 h-9"
      />
    </template>
    <div data-testid="r-hero-content">
      <slot name="content"></slot>
    </div>
  </RPanel>
</template>

<style scoped>
.r-hero-panel {
  background-image: url('../../../assets/images/logo_big.svg');
  background-position: right;
  background-repeat: no-repeat;
  background-size: contain;
}

@media screen and (max-width: 425px) {
  .r-hero-panel {
    background-position: 150px;
  }
}

@media screen and (max-width: 320px) {
  .r-hero-panel {
    background-position: 60px;
    background-size: 420px;
  }
}
</style>
